<template>
    <div class="container px-1 mx-auto">
        <section class="mb-32 text-gray-800">
            <div class="relative overflow-hidden bg-no-repeat bg-cover" style="background-position: 50%; background-image: url('https://i.natgeofe.com/k/57f627c4-44b3-4dd6-90e1-9762bdfd03f6/deserts-palm_3x2.jpg'); height: 300px;"></div>
            <div class="container px-1 text-gray-800 md:px-12">
                <div class="block px-1 py-10 rounded-lg shadow-lg md:py-6 md:px-6" style="margin-top: -100px; background: hsla(0, 0%, 100%, 0.8); backdrop-filter: blur(30px);">
                    <div class="px-1 rounded-lg">
                        <div class="flex flex-wrap justify-between mb-2">
                            <h2 class="w-full pl-2 text-2xl font-bold lg:w-6/12 sm:w-full md:w-6/12">
                                CUCI OpenData - สะสางดอกเบี้ย
                            </h2> 
                            <div class="max-w-4xl pl-2 mt-1 text-right sm:w-full md:w-1/2 lg:w-1/2">
                                <router-link to="/openDataRibaMain">
                                    <button  class="px-2 py-1 ml-1 font-bold text-white bg-gray-600 rounded btn-sm">
                                        <i class="w-5 h-5 fa-solid fa-home"> </i>
                                    </button>
                                </router-link>
                                <!-- <router-link to="/opendataRibaBarChartYear">
                                    <button class="px-2 py-1 ml-1 font-bold text-white rounded btn-sm" :class="reportType === 'year' ? 'bg-green-500' : 'bg-blue-500'">
                                        รายปี
                                    </button>
                                </router-link>
                                <router-link to="/opendataRibaBarChartMonth">
                                    <button  class="px-2 py-1 ml-1 font-bold text-white rounded btn-sm" :class="reportType === 'month' ? 'bg-green-500' : 'bg-blue-500'">
                                        รายเดือน
                                    </button>
                                </router-link> -->
                            </div>
                        </div>
                        <div class="flex flex-wrap justify-between mb-2">
                            <select v-model="selectedYear" class="block px-4 py-2 pr-8 leading-tight bg-white border border-gray-400 rounded shadow appearance-none sm:w-1/2 md:w-1/2 lg:w-1/6 xl:w-1/6 hover:border-gray-500 focus:outline-none focus:shadow-outline">
                                <option value="2568">2568</option>
                                <option value="2567">2567</option>
                                <option value="2566">2566</option>
                                <option value="2565">2565</option>
                                <option value="2564">2564</option>
                                <option value="2563">2563</option>
                                <option value="2562">2562</option>
                            </select>
                            <div class="max-w-4xl pl-2 mt-1 text-right sm:w-full md:w-1/2 lg:w-1/2 text:bold">
                                รวม : {{ totalTransfer }} ครั้ง
                            </div>
                        </div>
                        <div class="flex flex-wrap justify-center">
                            <div class="w-full sm:w-full md:w-full lg:w-full xl:w-3/4">
                                <apexchart 
                                    type="line" 
                                    height="350" 
                                    width="100%" 
                                    :options="chartOptions" 
                                    :series="series">
                                </apexchart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    mounted(){
        this.chartOptions.subtitle.text = 'สถิติจำนวนครั้งการสะสางสะสม'
        this.selectedYear = 2568
    },
    data(){
        return{
            selectedYear: '',
            reportType: 'month',
            totalTransfer: '',
            series: [{
                name: "Desktops",
                data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
            }],
            chartOptions: {
                subtitle: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 15,
                    offsetY: 15,
                    floating: false,
                    style: {
                        fontSize:  '16px',
                        fontWeight:  'bold',
                        fontFamily:  'Helvetica, Arial, sans-serif',
                        color:  '#9699a2'
                    },
                },
                colors: ['#ffa533'],
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'straight'
                },
                // title: {
                //     text: 'Product Trends by Month',
                //     align: 'left'
                // },
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                xaxis: {
                    categories: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                }
            },
            reportData:[
                {
                    year: 2562,
                    totalTransfer: 533,
                    report: [0, 0, 0, 0, 0, 1, 388, 394, 395, 398, 404, 533]
                },
                {
                    year: 2563,
                    totalTransfer: 9121,
                    report: [3974, 4086, 4132, 4185, 4229, 5082, 8413, 8526, 8584, 8627, 8652, 9654]
                },
                {
                    year: 2564,
                    totalTransfer: 11653,
                    report: [ 14428, 14542, 14633, 14677, 14713, 15358, 19570, 19689, 19771, 19837, 19869, 21307],
                },
                {
                    year: 2565,
                    totalTransfer: 16219,
                    report: [26893, 27076, 27200, 27314, 27369, 28952, 35427, 35600, 35746, 35872, 35936, 37526]
                },
                {
                    year: 2566,
                    totalTransfer: 16839,
                    report: [43632, 43839, 44035, 44208, 44273, 45735, 51027, 51223, 51469, 51618, 51708, 54361]
                },
                {
                    year: 2567,
                    totalTransfer: 21943,
                    report: [ 61791, 62066, 62376, 62595, 62709, 64589, 72378, 72688, 72931, 73175, 73318, 76304]
                },
                {
                    year: 2568,
                    totalTransfer: 10581,
                    report: [86885, 86885, 86885, 86885, 86885 , 86885, 86885, 86885, 86885, 86885, 86885, 86885],
                }
            ]
        }
    },
    watch: {
        selectedYear(){
            let data = this.reportData.find(data => data.year == this.selectedYear)
            this.series = [{
                data: data.report
            }]
            this.totalTransfer = data.totalTransfer
        }
    },
    methods: {
        
    }
}
</script>

<!-- <style lang="css" scoped>
    .apexcharts-data-label{
        color: black;
        /* rotate text to -90 */
        transform: rotate(-90deg) translateX(-10px) !important;
    }  
</style> -->